<template>
    <div class="recharge_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.go(-1)"></div>
            <div class="big_tit">{{$t('account.addAccount')}}</div>
        </div>
        <div class="wrap_box warp1">
            <div class="item">
                <div class="ari_font">{{$t('account.bank')}}：</div>
                <div>
                    <div class="item">
                        <div class="iconsp" @click="ationalshow=true">
                            <van-icon name="arrow-down" />
                        </div>
                        <input class="card" type="text" v-model="areashow" :placeholder="$t('accountUsdt.areaEmpty')" disabled>
                    </div>
                    <van-index-bar v-if="ationalshow">
                        <van-cell v-for="item in indexlist" :key="item.code" :title="item.name" @click="areaclick(item)" />
                    </van-index-bar>
                </div>
            </div>
            <!-- USDT-TRC20 表单 -->
            <div v-if="bank.area === 'USDT-TRC20'">
                <div class="item">
                    <div class="ari_font">{{$t('account.address')}}：</div>
                    <input class="card" type="text" v-model="bank.account" :placeholder="$t('account.addressTit')">
                </div>
            </div>
            <!-- 非 USDT-TRC20 表单 -->
            <div v-else>
				<div class="item">
				    <div class="ari_font">{{$t('invest_bank.bank')}}</div>
				    <input class="card" type="text" v-model="bank.bank" :placeholder="$t('accountUsdt.areaEmpty')">
				</div>
                <div class="item">
                    <div class="ari_font">{{$t('accountUsdt.name')}}</div>
                    <input class="card" type="text" v-model="bank.name" :placeholder="$t('accountUsdt.nameEmpty')">
                </div>
                <div class="item">
                    <div class="ari_font">{{$t('accountUsdt.account')}}</div>
                    <input class="card" type="text" v-model="bank.account" :placeholder="$t('accountUsdt.accountEmpty')">
                </div>
                <div class="item">
                    <div class="ari_font">CCI: </div>
                    <input class="card" type="text" v-model="bank.mobile" :placeholder="$t('CCI')">
                </div>
            </div>
        </div>
        <div class="basic_btn" @click="submitBtn">{{$t('account.submit')}}</div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch';
    import Api from "../../interface/index";
    import {
        Uploader, Button, DropdownMenu, DropdownItem, Toast, Field, CellGroup, Icon, IndexBar, Cell, IndexAnchor
    } from 'vant';
    import axios from 'axios';
    import bankdata from "../../otherjson/bank_data.json";
    
    Vue.use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem).use(Field).use(CellGroup).use(Icon).use(IndexBar).use(Cell).use(IndexAnchor);
    
    export default {
        name: "addcountUsdt",
        data() {
            return {
                bank: {
                    account: '',
                    name: '',
                    area: 'USDT-TRC20', // 初始默认选择 USDT-TRC20
                    bank: '',
                    uid: 0,
                    mobile: '' // 添加移动电话属性
                },
                fileList: [],
                type: 1,
                value: 0,
                value_bank: 0,
                wallets: [],
                banks: [],
                indexlist: [],
                Internationalcode: 522,
                ationalshow: false,
                areashow: "USDT-TRC20",
            };
        },
        created() {
            this.$parent.footer('user', false);
            this.areachoose();
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/user/wallet_type', {}).then(r => {
                    this.bank.bank ='';
                    this.bank.uid = this.$store.uid;
                });
            },
            submitBtn() {

                // 根据选择的 area 设置特定的值
                // let submissionData = { ...this.bank };

                if (this.bank.area === 'USDT-TRC20') {
                    if (this.bank.account.length !== 34 || !/^T[a-zA-Z0-9]{33}$/.test(this.bank.account)) {
                        Toast({
                            className: "toastName",
                            message: this.$t('account.banknum')
                        });
                        return;
                    }
                    // 设置 USDT-TRC20 特有的一些固定属性
                    this.bank.bank = 'USDT(TRC-20)';
                    this.bank.name = 'USDT User';
					this.bank.mobile = '20';
                } else {
                    // 验证非 USDT-TRC20 情况下的字段
                    if (!this.bank.name || !this.bank.account || !this.bank.mobile) {
                        Toast({
                            className: "toastName",
                            message: this.$t('accountUsdt.nameEmpty')
                        });
                        return;
                    }
                }
                if (this.bank.uid) {
                    Fetch('/user/bank_add', this.bank)
                    .then((r) => {
                        Toast({
                            className: "toastName",
                            message: this.$t('account.success')
                        });
                        setTimeout(() => {
                            this.$router.push('/user')
                        }, 1000);
                    }).catch((err) => {
                        Toast({
                            className: "toastName",
                            message: this.$t('account.success')
                        });
						setTimeout(() => {
						    this.$router.push('/user')
						}, 1000);
                    });
                } else {
                    Toast({
                        className: "toastName",
                        message: this.$t('account.uploadFail')
                    });
                    setTimeout(() => {
                        this.$router.push('/user')
                    }, 1000);
                }
            },
            areachoose() {
                this.indexlist = bankdata;
            },
            areaclick(item) {
                this.bank.area = item.code;
                this.areashow = item.name;
                this.ationalshow = false;
            }
        }
    };
</script>

<style lang="less" scoped>
    /deep/ .van-dropdown-menu__bar {
		box-shadow:none;
    }
	/deep/ .van-button--primary {
	    background-color: transparent;
	    border: none;
	    width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__input-wrapper {
	    width: 100%;
	}
	/deep/ .van-uploader__wrapper{
		width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__upload{
		width: 100%;
		height: 100%;
		margin:0;
	}
	/deep/ .van-uploader__preview{
		margin:0;
	}
	/deep/ .van-uploader__preview-image{
		width: 100%;
		height: 100%;
	}
	
	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}
	.big_tit{
		color: #FFF;
	}

    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
        margin-top: 12px;

        .item {
            height: 50px;
            padding: 0 16px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }
			.card{
				width: 100%;
			}
            input {
                line-height: 14px;
            }
			.van-field{
				padding-left: 0;
				font-weight:bold;
			}
		.iconsp {
		
        max-width: 70px;
		
        height:100%;
		white-space:nowrap;
		display: flex;
		justify-content: start;
		align-items: center;
		color: rgb(217,217,217);
		font-weight: bolder;
		font-size: 12px;
		margin-right: 5px;
		.van-icon{
			color: #333;
			font-weight: bolder;
		}
		.iconsp-div{
			overflow: hidden;
			text-overflow: ellipsis;
			text-align: center;
			white-space:nowrap;
			vertical-align: middle;
			line-height: 1;
		}
    }
        }
    }
	
	.bardiv{
			width: 100%;
			text-align: right;
			margin-bottom: 10px;
			padding-top: 10px;
			padding-right: 10px;
			position: fixed;
			top:5px;
			background-color:#FFF;
			z-index: 1;
	}
	.van-index-bar{
		background-color: #fff;
		width: 100%;
		position:absolute;
		top:0;
		left: 50%;
		transform: translateX(-50%);
		padding-top: 10px;
		
	/deep/	.van-index-bar__sidebar{
			height: 500px;
			overflow: hidden;
			display: none !important;
		}
	}

    .ari_font {
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
		margin-right: 5px;
    }

    .basic_btn {
        margin: 75px auto 0 auto;
    }
	.qrcode{
		padding-top: 30px;
		padding-bottom: 30px;
		text-align: center;
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 20px;
		}
		.upload{
			width: 100%;
			height: 100%;
		}
		.qrcode_img{
			width: 250px;
			height: 250px;
			margin: 0 auto;
			background: linear-gradient(to left, #999, #999) left top no-repeat, 
						linear-gradient(to bottom, #999, #999) left top no-repeat, 
						linear-gradient(to left, #999, #999) right top no-repeat,
						linear-gradient(to bottom, #999, #999) right top no-repeat, 
						linear-gradient(to left, #999, #999) left bottom no-repeat,
						linear-gradient(to bottom, #999, #999) left bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat;
			background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
			span{
				line-height: 220px;
			}
			img{
				width: 240px;
				height: 240px;
				position: relative;
				top: -255px;
			}
		}
	}
</style>
